import { makeStyles } from "@material-ui/core/styles";
import CardSpacer from "@saleor/components/CardSpacer";
import Container from "@saleor/components/Container";
import Grid from "@saleor/components/Grid";
// import Money from "@saleor/components/Money";
import RequirePermissions from "@saleor/components/RequirePermissions";
// import Skeleton from "@saleor/components/Skeleton";
import { UserPermissionProps } from "@saleor/types";
import { PermissionEnum } from "@saleor/types/globalTypes";
import React, { useEffect, useState } from "react";

import Orders from "../../../icons/Orders";
import Sales from "../../../icons/Sales";
import {
  Home_activities_edges_node,
  Home_productTopToday_edges_node,
  Home_salesToday_gross,
  Home_salesYesterday_gross
} from "../../types/Home";
import HomeActivityCard from "../HomeActivityCard";
import HomeAnalyticsCard from "../HomeAnalyticsCard";
import HomeHeader from "../HomeHeader";
import HomeNotificationTable from "../HomeNotificationTable/HomeNotificationTable";
import HomeProductListCard from "../HomeProductListCard";

const useStyles = makeStyles(
  theme => ({
    cardContainer: {
      display: "grid",
      gridColumnGap: theme.spacing(3),
      gridTemplateColumns: "1fr 1fr",
      [theme.breakpoints.down("sm")]: {
        gridColumnGap: theme.spacing(1)
      },
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "1fr"
      }
    },
    icon: {
      "& path": {
        fill: theme.palette.primary.main
      }
    },
    fontLeft: {
      textAlign: "left"
    }
  }),
  { name: "HomePage" }
);

export interface HomePageProps extends UserPermissionProps {
  activities: Home_activities_edges_node[];
  orders: number;
  orderspendingtoday: number;
  ordersyesterday: number;
  orderspendingyesterday: number;
  ordersToCapture: number;
  ordersToFulfill: number;
  productsOutOfStock: number;
  productvariantsOutOfStock: number;
  sales: Home_salesToday_gross;
  salesyesterday: Home_salesYesterday_gross;
  topProducts: Home_productTopToday_edges_node[];
  userName: string;
  onOrdersToCaptureClick: () => void;
  onOrdersToFulfillClick: () => void;
  onProductClick: (productId: string, variantId: string) => void;
  onProductsOutOfStockClick: () => void;
  onProductvariantsOutOfStockClick: () => void;
  language: string;
  setLanguageHandle: (event: any) => void;
  disabled?: boolean;
  isSelect?: boolean;
}

const HomePage: React.FC<HomePageProps> = props => {
  const {
    userName,
    orders = 0,
    orderspendingtoday = 0,
    ordersyesterday = 0,
    orderspendingyesterday = 0,
    sales,
    salesyesterday,
    topProducts,
    onProductClick,
    activities,
    onOrdersToCaptureClick,
    onOrdersToFulfillClick,
    onProductsOutOfStockClick,
    onProductvariantsOutOfStockClick,
    ordersToCapture,
    ordersToFulfill,
    productsOutOfStock,
    productvariantsOutOfStock,
    userPermissions,
    language,
    setLanguageHandle,
    disabled,
    isSelect
  } = props;
  const classes = useStyles(props);
  const [POT, setPOT] = useState("0");
  const [POTYES, setPOTYES] = useState("0");
  const [PaymentRatio, setPaymentRatio] = useState("0%");
  const [PaymentRatioYES, setPaymentRatioYES] = useState("0%");
  useEffect(() => {
    if (orders) {
      setPaymentRatio(
        Math.round((orders / (orders + orderspendingtoday)) * 100) + "%"
      );
      setPOT(Math.round((sales?.amount / orders) * 100) / 100 + "");
    } else {
      setPOT("0");
      setPaymentRatio("0%");
    }
    if (ordersyesterday) {
      setPOTYES(
        Math.round((salesyesterday?.amount / ordersyesterday) * 100) / 100 + ""
      );
      setPaymentRatioYES(
        Math.round(
          (ordersyesterday / (ordersyesterday + orderspendingyesterday)) * 100
        ) + "%"
      );
    } else {
      setPOTYES("0");
      setPaymentRatioYES("0%");
    }
  }, [orders, ordersyesterday]);
  return (
    <Container>
      <HomeHeader
        userName={userName}
        language={language}
        disabled={disabled}
        isSelect={isSelect}
        setLanguageHandle={setLanguageHandle}
      />
      <CardSpacer />
      <Grid>
        <div>
          <RequirePermissions
            userPermissions={userPermissions}
            requiredPermissions={[PermissionEnum.MANAGE_ORDERS]}
          >
            <div className={classes.cardContainer}>
              <HomeAnalyticsCard
                title={"Sales"}
                titleSpan="Today"
                titleSpan1="Yesterday"
                leftTitle1="Revenues"
                leftTitle2="POT"
                sales={sales?.amount}
                salesyesterday={salesyesterday?.amount}
                orderstoday={POT}
                ordersyesterday={POTYES}
                icon={
                  <Orders
                    className={classes.icon}
                    fontSize={"inherit"}
                    viewBox="0 0 64 64"
                  />
                }
              >
                {/* {orders === undefined ? (
                  <Skeleton style={{ width: "5em" }} />
                ) : (
                  <div className={classes.fontLeft}>{orders}</div>
                )}
                {ordersyesterday === undefined ? (
                  <Skeleton style={{ width: "5em" }} />
                ) : (
                  <div className={classes.fontLeft}>{ordersyesterday}</div>
                )}
                {sales ? (
                  <div className={classes.fontLeft}>
                    <Money money={sales} />
                  </div>
                ) : (
                  <Skeleton style={{ width: "5em" }} />
                )}
                {salesyesterday ? (
                  <div className={classes.fontLeft}>
                    <Money money={salesyesterday} />
                  </div>
                ) : (
                  <Skeleton style={{ width: "5em" }} />
                )} */}
              </HomeAnalyticsCard>

              <HomeAnalyticsCard
                title={"Orders"}
                titleSpan="Today"
                titleSpan1="Yesterday"
                leftTitle1="Fully Paid"
                leftTitle2="Pending"
                sales={orders + ""}
                salesyesterday={ordersyesterday + ""}
                orderstoday={orderspendingtoday + ""}
                ordersyesterday={orderspendingyesterday + ""}
                PaymentRatio1={PaymentRatio}
                PaymentRatio2={PaymentRatioYES}
                icon={
                  <Sales
                    className={classes.icon}
                    fontSize={"inherit"}
                    viewBox="0 0 64 64"
                  />
                }
              >
                {/* {orders === undefined ? (
                  <Skeleton style={{ width: "5em" }} />
                ) : (
                  <div className={classes.fontLeft}>{orders}</div>
                )}
                {ordersyesterday === undefined ? (
                  <Skeleton style={{ width: "5em" }} />
                ) : (
                  <div className={classes.fontLeft}>{ordersyesterday}</div>
                )}
                {orders ? (
                  <div className={classes.fontLeft}>
                    <Money money={Orders} />
                  </div>
                ) : (
                  <Skeleton style={{ width: "5em" }} />
                )}
                {ordersyesterday ? (
                  <div className={classes.fontLeft}>
                    <Money money={ordersyesterday} />
                  </div>
                ) : (
                  <Skeleton style={{ width: "5em" }} />
                )} */}
              </HomeAnalyticsCard>
            </div>
          </RequirePermissions>
          <HomeNotificationTable
            onOrdersToCaptureClick={onOrdersToCaptureClick}
            onOrdersToFulfillClick={onOrdersToFulfillClick}
            onProductsOutOfStockClick={onProductsOutOfStockClick}
            onProductvariantsOutOfStockClick={onProductvariantsOutOfStockClick}
            ordersToCapture={ordersToCapture}
            ordersToFulfill={ordersToFulfill}
            productsOutOfStock={productsOutOfStock}
            productvariantsOutOfStock={productvariantsOutOfStock}
            userPermissions={userPermissions}
          />
          <CardSpacer />
          <RequirePermissions
            userPermissions={userPermissions}
            requiredPermissions={[
              PermissionEnum.MANAGE_ORDERS,
              PermissionEnum.MANAGE_PRODUCTS
            ]}
          >
            <HomeProductListCard
              onRowClick={onProductClick}
              topProducts={topProducts}
            />
            <CardSpacer />
          </RequirePermissions>
        </div>
        <div>
          <RequirePermissions
            userPermissions={userPermissions}
            requiredPermissions={[PermissionEnum.MANAGE_ORDERS]}
          >
            <HomeActivityCard activities={activities} />
          </RequirePermissions>
        </div>
      </Grid>
    </Container>
  );
};
HomePage.displayName = "HomePage";
export default HomePage;
